module.exports = __webpack_public_path__ + "media/images/doodle-home-7d905de4e6f401f7f437442f4887d73d.png";